/**
 * useInsights Hook
 * Fetches paginated insights using TanStack Query's useInfiniteQuery
 * Supports server-side search and sentiment filtering
 */

import { useInfiniteQuery } from '@tanstack/react-query'
import { insightsRepo } from '@/lib/repositories'
import { FEED_PAGE_SIZE } from '@/lib/types/pagination'
import type { Insight } from '@/lib/repositories/interfaces/IInsightsRepository'

export type { Insight }

export const INSIGHTS_QUERY_KEY = ['insights'] as const

export interface InsightFilters {
  search?: string
  sentiment?: 'bullish' | 'bearish' | 'neutral'
}

export function useInsights(filters?: InsightFilters) {
  return useInfiniteQuery({
    queryKey: [...INSIGHTS_QUERY_KEY, filters],
    queryFn: ({ pageParam }) =>
      insightsRepo.getInsightsPaginated({
        cursor: pageParam?.cursor,
        cursorId: pageParam?.cursorId,
        limit: FEED_PAGE_SIZE,
        search: filters?.search || undefined,
        sentiment: filters?.sentiment,
      }),
    initialPageParam: undefined as
      | { cursor: string; cursorId: string }
      | undefined,
    getNextPageParam: (lastPage) =>
      lastPage.hasMore
        ? { cursor: lastPage.nextCursor!, cursorId: lastPage.nextCursorId! }
        : undefined,
    staleTime: 30_000,
  })
}
